import { createApp, h, provide } from "vue";
import AppLayout from "./layout/index.vue";
import router from "./router";
import store from "./store";
import helper from "./helpers";
import upperFirst from "lodash/upperFirst";
import camelCase from "lodash/camelCase";
import "./plugins/global-config";
import "./scss/app.scss";
import errorHandler from "./plugins/interceptor";
import VueJsBridge, { $fetch } from "vue-bridge-gateway";
import { ApolloClient, InMemoryCache } from "@apollo/client";
import { DefaultApolloClient } from "@vue/apollo-composable";
import { Locale } from "vant";
// import i18n from "./locales/index";
import { createI18n } from "vue-i18n";
import en from "./locales/en/index";
import kh from "./locales/kh/index";
import enUS from "vant/lib/locale/lang/en-US";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  faRotate,
  faXmark,
  faCalendarDays,
  faUser,
  faPhone,
  faWifi,
  faMagnifyingGlass,
  faCheck,
  faCircle,
  faEarthAmericas,
  faHouse,
  faStore,
  faDeleteLeft,
} from "@fortawesome/free-solid-svg-icons";
import {
  Button,
  Cell,
  CellGroup,
  Divider,
  Form,
  Field,
  List,
  Empty,
  Tab,
  Tabs,
  Popup,
  Search,
  Picker,
  Icon,
  Calendar,
  Tabbar,
  TabbarItem,
  Popover,
  Toast,
  NumberKeyboard,
} from "vant";

const defaultClient = new ApolloClient({
  uri: "https://rickandmortyapi.com/graphql",
  cache: new InMemoryCache(),
});

const messages = {
  en: en,
  kh: kh,
};

const i18n = createI18n({
  locale: "en",
  fallbackLocale: "en",
  messages,
});

const app = createApp({
  setup() {
    provide(DefaultApolloClient, defaultClient);
  },
  render() {
    return h(AppLayout);
  },
});
app.config.devtools = true;

// vant
app
  .use(Button)
  .use(Cell)
  .use(CellGroup)
  .use(Divider)
  .use(Form)
  .use(Field)
  .use(List)
  .use(Empty)
  .use(Tab)
  .use(Tabs)
  .use(Popup)
  .use(Search)
  .use(Picker)
  .use(Icon)
  .use(Calendar)
  .use(Tabbar)
  .use(TabbarItem)
  .use(Popover)
  .use(Toast)
  .use(NumberKeyboard);
const requireComponent = require.context(
  "./components",
  true,
  /(st-)[\w-]+\.vue$/
);
requireComponent.keys().forEach((fileName) => {
  // Get component config
  const componentConfig = requireComponent(fileName);
  const componentName = upperFirst(
    camelCase(
      fileName.replace(/^\.\/ui\/|^\.\/ui-custom\//, "").replace(/\.\w+$/, "")
    )
  );
  app.component(componentName, componentConfig.default || componentConfig);
});
errorHandler($fetch);

// Local Storage
Locale.use("en", enUS);
library.add(
  faRotate,
  faXmark,
  faCalendarDays,
  faUser,
  faPhone,
  faWifi,
  faMagnifyingGlass,
  faCheck,
  faCircle,
  faEarthAmericas,
  faHouse,
  faStore,
  faDeleteLeft
);

router.beforeEach((to, from, next) => {
  if (from.name == undefined) {
    // Main Route
    // Clear
    localStorage.removeItem("destinationFrom");
    localStorage.removeItem("destinationFromId");
    localStorage.removeItem("destinationTo");
    localStorage.removeItem("destinationToId");
    localStorage.removeItem("dateFrom");
    localStorage.removeItem("types");
    localStorage.removeItem("clearData");
    localStorage.removeItem("dateTo");
    localStorage.removeItem("journeyid");
    localStorage.removeItem("price");
    localStorage.removeItem("departure");
    localStorage.removeItem("seat");
    localStorage.removeItem("seatlabel");
    localStorage.removeItem("journeyidback");
    localStorage.removeItem("departureback");
    localStorage.removeItem("priceback");
    localStorage.removeItem("seatback");
    localStorage.removeItem("seatlabelback");
    localStorage.removeItem("gender");
    localStorage.removeItem("genderBack");
    localStorage.removeItem("total");
    localStorage.removeItem("transactionId");
    localStorage.removeItem("boardingpoint");
    localStorage.removeItem("dropoff");
    localStorage.removeItem("boardingpointB");
    localStorage.removeItem("dropoffB");
    localStorage.removeItem("arrivalDate");
    localStorage.removeItem("arrivalDateBack");
    localStorage.removeItem("reloadTicket");
    localStorage.removeItem("ticketSuccessId");
    localStorage.removeItem("idbooking");
    localStorage.removeItem("boardingpointBId");
    localStorage.removeItem("bPointid");
    localStorage.removeItem("dropoffId");
    localStorage.removeItem("dropoffBId");
    localStorage.removeItem("lang");
  }
  if (from.name == "payment-cart") {
    if (to.name == "payment-success" || to.name == "Home") {
      next(true);
    } else {
      next(false);
    }
  } else if (from.name == "Home") {
    if (to.name == "schedule-list") {
      next(true);
    } else if (to.name == "show-ticket") {
      if (localStorage.getItem("homepage") != null) {
        if (localStorage.getItem("homepage") == "1") {
          next(false);
        } else {
          next(true);
        }
      } else {
        next(true);
      }
    } else {
      next(false);
    }
  } else if (from.name == "show-ticket") {
    if (to.name == "Home" || to.name == "ticket-booking") {
      next(true);
    } else {
      next(false);
    }
  } else if (from.name == "payment-success") {
    if (
      to.name == "Home" ||
      to.name == "ticket-booking" ||
      to.name == "show-ticket"
    ) {
      next(true);
    } else {
      next(false);
    }
  } else if (from.name == "ticket-booking") {
    if (to.name == "Home" || to.name == "show-ticket") {
      next(true);
    } else {
      next(false);
    }
    // } else if(from.name == "passenger-info"){
    //   if(to.name == "choose-seat") {
    //     localStorage.removeItem('seat');
    //     localStorage.removeItem('seatlabel');
    //   }else if(to.name == "choose-seat-back"){
    //     localStorage.removeItem('seatback');
    //     localStorage.removeItem('seatlabelback');
    //   }
    //   next(true);
    // } else if(from.name == "choose-seat"){
    //   if(to.name == "passenger-info") {
    //     if(localStorage.getItem('seat') != ""){
    //       next("schedule-list");
    //     } else {
    //       next(true);
    //     }
    //   } else {
    //     next(true);
    //   }
  } else {
    next(true);
  }
});

/* 
  QA server :
    https://qacltom.udaya-tech.com/vetTKMiniApp/
    d215ff36-cd41-44d2-8043-db8ffb89005d
*/
/* 
  Production Server :
    https://apicamset.utlog.net/vetTKMiniProApp/ 
    bearer 606e9ffc-36c5-40ad-838e-f2e6bbb2fda9
*/

localStorage.setItem("url", "https://qacltom.udaya-tech.com/vetTKMiniApp/");
localStorage.setItem("bearer", "Bearer d215ff36-cd41-44d2-8043-db8ffb89005d");

app.component("font-awesome-icon", FontAwesomeIcon);
app.use(VueJsBridge);
app.use(i18n);
app.mixin(helper).use(router).use(store).mount("#app");
